<template>
  <div id="layout">
    <div :class="[{ open: menuOpen }, '__menu']">
      <div class="menuClose" @click="menuOpen = false">
        <i class="pi pi-times"></i>
      </div>
      <div class="topbar">
        <div class="__icons">
          <Button
            @click="logoutUser()"
            v-tooltip.bottom="'Logout'"
            class="logout p-button-rounded p-button-text"
            icon="pi pi-sign-out"
          />
          <Div
            class="avatar"
            @click="gotoprofile(), menuOpen = false"
            v-tooltip.bottom="
              userProfile.firstname + ' ' + userProfile.lastname
            "
            ><i class="pi pi-user"></i
          ></Div>
        </div>
        <!-- <p class="name">{{userProfile.firstname}} {{userProfile.lastname}}</p> -->
        <p class="role">{{ userProfile.role }}</p>
      </div>
      <div class="line"></div>
      <div class="__nav">
        <role-links :role="userProfile.role" @menuclicked="menuOpen = false" />
      </div>
      <router-link to="/survey" class="feedback"
        >Feedback?</router-link
      >
    </div>
    <div class="menuOpen" @click="menuOpen = true">
      <i class="pi pi-bars"></i>
    </div>
    <div class="__content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { fb_auth, fb_db } from "../firebase";
import Tooltip from "primevue/tooltip";
import RoleLinks from "@/components/RoleLinks.vue";

export default {
  name: "Layout",
  directives: {
    tooltip: Tooltip,
  },
  components: {
    RoleLinks,
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  async mounted() {
    switch (this.userProfile.role) {
      case "Operator":
        console.log("user role = operator", this.$router);
        if (this.$router.to != "/pmcs") {
          this.$router.push("/pmcs");
        }
        break;

      case "Mechanic":
        console.log("user role = mechanic");
        if (this.$router.to.name != "/assigned") {
          this.$router.push("/assigned");
        }
        break;

      case "Org. Leader":
        console.log("user role = lead");
        if (this.$router.to != "/leaddashboard") {
          this.$router.push("/leaddashboard");
        }
        break;

      case "Maint. Manager":
        console.log("user role = manager");
        if (this.$router.to != "/faultsworkbench") {
          this.$router.push("/faultsworkbench");
        }
        break;

      case "Clerk":
        console.log("user role = clerk");
        if (this.$router.to != "/addtogcss") {
          this.$router.push("/addtogcss");
        }
        break;

      default:
        break;
    }
  },

  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    logoutUser() {
      fb_auth.signOut();
      this.$store.dispatch("clearData");
      this.$router.push("/login");
    },
    gotoprofile() {
      this.$router.push("/profile");
    },
    save() {
      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "Data Saved",
        life: 3000,
      });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
  },
};
</script>

<style lang="scss" scoped>
#layout {
  color: #999999;
  display: grid;
  grid-template-columns: 270px 1fr;
  grid-template-rows: 100vh;

  .__menu {
    box-shadow: 3px 3px 6px #eee;
    text-align: left;
    padding-left: 40px;

    .topbar {
      margin-top: 10px;
      height: 40px;
      display: inline-flex;

      .__icons {
        width: 80px;
        display: inline-flex;
      }

      .role {
        line-height: 40px;
        margin: 0;
        padding-left: 5px;
      }

      .logout {
        width: 40px;
        height: 40px;
      }

      .avatar {
        width: 30px;
        height: 30px;
        margin: 5px;
        border-radius: 30px;
        background: #eee;
        line-height: 30px;
        text-align: center;
      }
    }

    .line {
      width: 85%;
      height: 1px;
      background: #eee;
      margin: 15px 0px 30px 0px;
    }

    .__nav {
    }
  }

  .__content {
    overflow-y: scroll;
    padding: 20px;
  }

  .__content::-webkit-scrollbar-track {
    background-color: white;
  }

  .__content::-webkit-scrollbar {
    width: 10px;
  }

  .__content::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 5px;
  }
}

.menuOpen,
.menuClose {
  display: none;
}

@media only screen and (max-width: 768px) {
  #layout {
    display: block;
  }

  .__menu {
    position: absolute;
    width: 300px;
    height: 100%;
    background: white;
    z-index: 1;
    left: -150%;
    transition: all 0.3s ease;
  }

  .open {
    left: 0;
  }

  .menuOpen {
    display: block;
    position: fixed;
    width: 40px;
    height: 40px;
    background: white;
    transition: background 0.3s ease;
    border-radius: 0 0 15px 0;
    top: 0px;
    left: 0px;
    box-shadow: 2px 2px 4px #ddd;
    line-height: 45px;

    .i {
      font-size: 20px;
    }
  }

  .menuClose {
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    background: white;
    transition: background 0.3s ease;
    border-radius: 0 0 0 15px;
    right: 0px;
    top: 0px;
    box-shadow: 2px 2px 4px #ddd;
    line-height: 45px;
  }

  .feedback {
    position: relative;
    top: -20px;
  }
}
</style>